import { configureStore } from "@reduxjs/toolkit"
import APIResponseSlice from "./slices/APIResponseSlice"
import MSALSlice from "./slices/MSALSlice"
import CateringOrderInputStatesSlice from "./slices/CateringOrderInputStatesSlice"
import TranslationSlice from "./slices/TranslationSlice.ts"

export const store = configureStore({
  reducer: {
    MSALAuth: MSALSlice,
    APIResponse: APIResponseSlice,
    InputStates: CateringOrderInputStatesSlice,
    Translation: TranslationSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
})
